import React from 'react';

const TrustpilotStars = ({ starRating }) => (
  <span className="d-none l-fl ie-fl1">
    <div className="rating-holder">
      <div className="c-rating fl ie-fl1" data-rating-value={starRating}>
        <span
          role="img"
          aria-label={`CEF TrustPilot scores ${starRating} stars`}></span>
        <span
          role="img"
          aria-label={`CEF TrustPilot scores ${starRating} stars`}></span>
        <span
          role="img"
          aria-label={`CEF TrustPilot scores ${starRating} stars`}></span>
        <span
          role="img"
          aria-label={`CEF TrustPilot scores ${starRating} stars`}></span>
        <span
          role="img"
          aria-label={`CEF TrustPilot scores ${starRating} stars`}></span>
      </div>
    </div>
  </span>
);

export default TrustpilotStars;
